import React from "react";
import { withNavBars } from "../../HOCs";
import SalesManagerDashboard from "./dashboard";

class SalesManagerDashboardParent extends React.Component {
    render() {
        return <SalesManagerDashboard {...this.props} />;
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(SalesManagerDashboardParent, props);